import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import FrameComponent4 from "../components/FrameComponent4";

const Term1 = () => {
  const navigate = useNavigate();

  const onToTiKhonClick = useCallback(() => {
    navigate("/31-sign-in1");
  }, [navigate]);

  return (
    <div className="min-h-screen w-full bg-light-primary-key-background flex flex-col overflow-y-auto px-4 pt-4 pb-[calc(env(safe-area-inset-bottom)+120px)] gap-10 leading-[normal] tracking-[normal] text-left text-base text-light-text font-text-regular-lowercase">
      <div className="flex flex-col items-start gap-10">
        <div
          className="font-medium cursor-pointer"
          onClick={onToTiKhonClick}
        >{`<  Tạo tài khoản`}</div>
        <div className="flex flex-col items-start gap-4 text-3xl text-dark-text">
          <h1 className="m-0 font-semibold text-4xl">Điều khoản</h1>
          <h3 className="m-0 font-semibold text-light-text text-xl">
            Đọc kĩ trước khi tạo tài khoản
          </h3>
        </div>
      </div>

      <main className="text-dark-text text-base leading-[140%] whitespace-pre-line">
        <section className="max-w-full">
          <p className="font-medium">
            Chào mừng bạn đến với GiGi – ứng dụng tương tác và điều khiển robot trò chuyện thông minh hoạt động trong thế giới thực. Vui lòng đọc kỹ các Điều Khoản Sử Dụng dưới đây trước khi sử dụng sản phẩm của chúng tôi.
          </p>

          <p className="font-semibold mt-6">1. Giới thiệu về GiGi</p>
          <p className="font-medium">
            GiGi là một robot trò chuyện thông minh (chatbot) được tích hợp trí tuệ nhân tạo, có thể tương tác bằng giọng nói hoặc văn bản, và hoạt động trực tiếp ngoài đời thật thông qua hệ thống điều khiển từ ứng dụng này. Ứng dụng giúp bạn giao tiếp, điều khiển, lập trình hành vi và theo dõi hoạt động của robot GiGi.
          </p>

          <p className="font-semibold mt-6">2. Chấp thuận điều khoản</p>
          <p className="font-medium">
            Khi sử dụng ứng dụng GiGi, bạn đồng ý với tất cả các điều khoản được nêu tại đây. Nếu bạn không đồng ý với bất kỳ phần nào của điều khoản, vui lòng ngừng sử dụng sản phẩm ngay lập tức.
          </p>

          <p className="font-semibold mt-6">3. Quyền sở hữu trí tuệ</p>
          <ul className="list-disc pl-5">
            <li className="font-medium">
              Mọi nội dung, dữ liệu, mã nguồn, thiết kế, và tính năng trong ứng dụng và robot GiGi đều thuộc quyền sở hữu của công ty.
            </li>
            <li className="font-medium">
              Người dùng không được sao chép, sửa đổi, phân phối lại hoặc sử dụng trái phép bất kỳ phần nào của sản phẩm.
            </li>
          </ul>

          <p className="font-semibold mt-6">4. Quy định sử dụng</p>
          <p className="font-medium">Người dùng cam kết:</p>
          <ul className="list-disc pl-5">
            <li className="font-medium">
              Không sử dụng GiGi vào các mục đích vi phạm pháp luật, đạo đức xã hội, hoặc gây hại cho cá nhân/tổ chức khác.
            </li>
            <li className="font-medium">
              Không can thiệp, hack, hoặc khai thác lỗ hổng của hệ thống robot hoặc ứng dụng.
            </li>
            <li className="font-medium">
              Không lập trình robot GiGi để thực hiện hành vi nguy hiểm, đe dọa, theo dõi trái phép hoặc phá hoại tài sản.
            </li>
          </ul>

          <p className="font-semibold mt-6">5. Trách nhiệm và giới hạn</p>
          <ul className="list-disc pl-5">
            <li className="font-medium">
              Chúng tôi không chịu trách nhiệm với bất kỳ thiệt hại trực tiếp hoặc gián tiếp nào phát sinh từ việc sử dụng GiGi sai cách hoặc không đúng hướng dẫn.
            </li>
            <li className="font-medium">
              Robot GiGi chỉ nên được sử dụng trong môi trường an toàn, có kiểm soát và được người trưởng thành giám sát nếu người sử dụng là trẻ vị thành niên.
            </li>
          </ul>

          <p className="font-semibold mt-6">6. Cập nhật và thay đổi</p>
          <p className="font-medium">
            Chúng tôi có quyền thay đổi nội dung Điều Khoản Sử Dụng bất kỳ lúc nào. Những thay đổi sẽ được thông báo thông qua ứng dụng hoặc email đăng ký. Việc tiếp tục sử dụng GiGi sau khi điều khoản được cập nhật đồng nghĩa với việc bạn đã chấp nhận các thay đổi đó.
          </p>

          <p className="font-semibold mt-6">7. Liên hệ</p>
          <p className="font-medium">Mọi thắc mắc hoặc yêu cầu hỗ trợ vui lòng liên hệ:</p>
          <ul className="list-disc pl-5">
            <li className="font-medium">Email: gigitheairobot@gmail.com</li>
            <li className="font-medium">Website: https://www.gigitherobot.com</li>
            <li className="font-medium">Hotline: 0948.382.228</li>
          </ul>

          <p className="font-medium mt-4">
            Cảm ơn bạn đã tin tưởng và sử dụng GiGi – người bạn trò chuyện thông minh và đáng yêu của bạn trong đời sống hằng ngày!
          </p>
        </section>
      </main>

      <FrameComponent4
        tiCKVNgViIuKh="Tôi đã đọc kỹ và đồng ý với điều khoản"
        onClickContinue={() => navigate("/31-sign-in1")}
      />
    </div>
  );
};

export default Term1;